// Static map from route component → tabmenu i18n key (keep in sync with router meta.title)
const COMPONENT_TABMENU_MAP = {
  dataScreening: 'tabmenu.name49',
  activateData: 'tabmenu.name50',
  realTimeMonitoring: 'tabmenu.name56',
  usage: 'tabmenu.name57',
  faultStatistics: 'tabmenu.name58',
  regionalDistribution: 'tabmenu.name59',
  dataSummary: 'tabmenu.name63',
  appSituation: 'tabmenu.name65',
  systemNotification: 'tabmenu.name33',
  setting: 'tabmenu.name34',
  simcardmanagement: 'tabmenu.name14',
  order: 'tabmenu.name43',
  systemuserlist: 'tabmenu.name21',
  systemroleslist: 'tabmenu.name22',
  permissionrulelist: 'tabmenu.name23',
  purview: 'tabmenu.name35',
  manufacturerslist: 'tabmenu.name26',
  smsConfiguration: 'bike.name533',
  manufactureruserlist: 'tabmenu.name27',
  manufacturersroleslist: 'tabmenu.name36',
  merchantlist: 'tabmenu.name29',
  merchantuserlist: 'tabmenu.name30',
  merchantroleslist: 'tabmenu.name37',
  franchiseeslist: 'tabmenu.name31',
  franchiseesroleslist: 'tabmenu.name46',
  franchiseesuserlist: 'tabmenu.name32',
  demoAccountManagement: 'tabmenu.name71',
  customerServiceConfiguration: 'tabmenu.name72',
  logpagelist: 'tabmenu.name24',
  limitedUpgradeTool: 'tabmenu.name5',
  oatManagement: 'tabmenu.name6',
  firmware: 'tabmenu.name10',
  batchupgrade: 'tabmenu.name55',
  bikelist: 'tabmenu.name8',
  modellist: 'tabmenu.name9',
  summaryModels: 'tabmenu.name67',
  iotlist: 'tabmenu.name41',
  faultmanagement: 'tabmenu.name11',
  visualReport: 'tabmenu.name47',
  debuggingReport: 'tabmenu.name4',
  productCertificate: 'tabmenu.name66',
  cyclinglist: 'tabmenu.name38',
  roadbooklist: 'tabmenu.name39',
  overviewapplisting: 'tabmenu.name17',
  overviewappusers: 'tabmenu.name18',
  feedbacklist: 'tabmenu.name42',
  pushlist: 'tabmenu.name45',
  sysintroduction: 'tabmenu.name44',
  appConfiguration: 'tabmenu.name60',
  electronicfence: 'tabmenu.name52',
  reconciliation: 'tabmenu.name54',
  transactionRecord: 'tabmenu.name61',
  refundRecord: 'tabmenu.name62',
  maintenanceRecord: 'tabmenu.name68',
  salesRecord: 'tabmenu.name69'
}

export function getTabmenuKeyByComponent (component) {
  if (!component) return ''
  const key = String(component).replace(/^\//, '')
  const tabmenuKey = COMPONENT_TABMENU_MAP[key] || ''
  if (!tabmenuKey && process.env.NODE_ENV !== 'production') {
    console.warn(`[sidebarMenuLabel] Missing tabmenu i18n key for component "${key}"`)
  }
  return tabmenuKey
}
